import { createAction } from 'redux-actions'
import { types } from 'features/progressBar/store/types'

export const progressSuccess = createAction(types.PROGRESS_SUCCESS)
export const progressError = createAction(types.PROGRESS_ERROR)
export const progressPending = createAction(types.PROGRESS_PENDING)
export const progressInactive = createAction(types.PROGRESS_INACTIVE)



// WEBPACK FOOTER //
// ./src/features/progressBar/store/actions.js